import React from "react";
import ValidatedInput from "../../commonComponents/util/ValidatedInput";
import CurrencyFormatInput from "../../commonComponents/util/CurrencyFormatInput";
import Select from "../../commonComponents/util/Select";
import RadioGroup from "../../commonComponents/util/RadioGroup";
import AutocompleteInput from "../../commonComponents/util/AutocompleteInput";
import UploadAttachments from "../../commonComponents/shared/UploadAttachments";
import PaymentInfo from "../../applicationsComponents/newApplication/PaymentInfo";
import {
  concatenateAddressLabel,
  formatCurrency,
  formatReferenceOptions,
  getApplicationPayee,
  stripCurrencyFormat
} from "../../../lib/utils";
import { PayeeTypes, SourceTypes } from "../../../lib/constants";

export default class CampaignRecipientApplication extends React.Component {
  constructor(props) {
    super(props);

    const state = {
      application: {
        amount: "",
        note: "",
        attachments: [],
        sourceId: "",
        individualCategoryId: "",
        paymentInfo: {
          fundId: (props.recipient.isIsraeli ? props.defaultIsraelFund : props.defaultUSFund) || "",
          payTo: props.recipient.trustedPayee ? PayeeTypes.TrustedPayee : PayeeTypes.Recipient,
          thirdParty: {
            referenceId: "",
            useRecipientAddress: false,
            isIsraeli: props.recipient.isIsraeli,
            firstName: "",
            lastName: "",
            address: {},
            bankNumber: "",
            branchNumber: "",
            accountNumber: "",
            accountHolder: "",
            careOf: ""
          },
          checkMemo: "",
          reportMemo: ""
        }
      },
      applicationSourceType: SourceTypes.New,
      thirdPartyPayeeType: SourceTypes.New,
      showCareOf: false,
      setTrustedPayee: false
    };
    state.initialState = state;

    this.state = state;
  }

  componentDidMount() {
    this.props.onChange("application", this.state.application); //Set application properties in parent
  }

  onChange = (name, value) => {
    this.setState({ [name]: value });
  };

  updateApplication = (name, value) => {
    this.setState(
      {
        application: { ...this.state.application, [name]: value }
      },
      () => this.props.onChange("application", this.state.application)
    );
  };

  updatePaymentInfo = (name, value) => {
    const { application } = this.state;
    this.setState(
      {
        application: {
          ...application,
          paymentInfo: {
            ...application.paymentInfo,
            [name]: value
          }
        }
      },
      () => this.props.onChange("application", this.state.application)
    );
  };

  updateDataErrors = (name, err) => {
    let dataErrors = [...this.props.dataErrors];

    if (!err) dataErrors = dataErrors.filter(err => err !== name);
    else if (err && !dataErrors[name]) dataErrors.push(name);

    this.props.onChange("dataErrors", dataErrors);
  };

  render() {
    const { application, applicationSourceType, initialState, thirdPartyPayeeType, showCareOf } = this.state;
    const { campaign, campaignIndivCategories, recipient, recipientTypes, references, israelFunds, usFunds, defaultIsraelFund, defaultUSFund, submitAttempted } = this.props;
    const payee = getApplicationPayee(application.paymentInfo, recipient);

    return (
      <div>
        <div className="modal-section">
          <div className="overflow-auto">

            <div className="modal-row">
              <div className="column-half column-half-left">
                <ValidatedInput
                  input={<CurrencyFormatInput isIsraeli={payee.isIsraeli} />}
                  label="Amount"
                  name="amount"
                  value={application.amount}
                  onChange={this.updateApplication}
                  validated={true}
                  showValidationError={true}
                  validate={val => {
                    const isValid = !val || (stripCurrencyFormat(val) <= (payee.isIsraeli ? campaign.maxAmountShekel : campaign.maxAmountDollar));
                    this.updateDataErrors("applicationAmount", !isValid);
                    return isValid;
                  }}
                  errorMessage={`Amount cannot exceed ${formatCurrency(
                    payee.isIsraeli ? campaign.maxAmountShekel : campaign.maxAmountDollar,
                    payee.isIsraeli
                  )}`}
                />
              </div>
              <div className="column-half column-half-right">
                <label className="input-label">Category</label>
                <Select clearable={true} 
                  name="individualCategoryId" value={application.individualCategoryId}
                  options={campaignIndivCategories.filter(c => c.active !== false)}
                  onChange={e => this.updateApplication(e.target.name, e.target.value)} />
              </div>
            </div>
            <div className="modal-row" >
              <div style={{width: "100%"}}>
                <label className="input-label">Note</label>
                <textarea
                  name="note"
                  value={application.note}
                  tabIndex={450}
                  onChange={e => this.updateApplication(e.target.name, e.target.value)}
                />
              </div>
            </div>
            <div className="modal-row">
              <UploadAttachments
                files={application.attachments}
                name="attachments"
                onChange={this.updateApplication}
              />
            </div>

            <div className="modal-row flex-center" style={{ marginTop: "24px", marginBottom: "24px" }}>
              <div className="column-half column-half-left">
                <RadioGroup
                  title="Source"
                  options={[
                    { key: SourceTypes.New, value: "Enter New" },
                    {
                      key: SourceTypes.Reference,
                      value: "Choose Reference",
                      disabled: !recipient.references.length
                    }
                  ]}
                  name="applicationSourceType"
                  value={applicationSourceType}
                  onChange={(name, val) => {
                    this.onChange(name, val);
                    this.updateApplication("sourceId", "");
                  }}
                />
              </div>
              <div className="column-half column-half-right">
                {applicationSourceType === SourceTypes.Reference ? (
                  <Select
                    options={(recipient.references || []).map(ref => ({
                      key: ref.referenceId,
                      value: ref.displayName
                    }))}
                    name="sourceId"
                    value={application.sourceId}
                    onChange={e => this.updateApplication(e.target.name, e.target.value)}
                  />
                ) : (
                    <AutocompleteInput
                      showList={true}
                      placeholder="Search references"
                      name="sourceId"
                      value={application.sourceId}
                      options={formatReferenceOptions(
                        references.data.filter(
                          r => (recipient.references || [])
                            .map(ref => ref.referenceId)
                            .indexOf(r.referenceId) < 0
                        )
                      )}
                      update={this.updateApplication}
                    />
                  )}
              </div>
            </div>

            <div>
              <PaymentInfo
                campaignApplication={true}
                submitAttempted={submitAttempted}
                paymentInfo={application.paymentInfo}
                payeeIsIsraeli={payee.isIsraeli}
                initialThirdParty={{
                  ...initialState.application.paymentInfo.thirdParty,
                  isIsraeli: recipient.isIsraeli
                }}
                trustedPayee={recipient.trustedPayee}
                onChange={this.onChange}
                updateApplication={this.updateApplication}
                updatePaymentInfo={this.updatePaymentInfo}
                funds={payee.isIsraeli ? israelFunds : usFunds}
                defaultUSFund={defaultUSFund}
                defaultIsraeliFund={defaultIsraelFund}
                thirdPartyPayeeType={thirdPartyPayeeType}
                showCareOf={showCareOf}
                recipientReferences={recipient.references.filter(
                  ref => ref.isPayable
                )}
                recipientAddress={!recipient.isIsraeli && recipient.address && recipient.address.street
                  ? concatenateAddressLabel(recipient.address) : ""
                }
                recipientTypes={recipientTypes}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignsCommon/CampaignRecipientApplication.jsx